<section class="access-panel">
  <button
    type="button"
    class="close-button"
    (click)="close()"
    aria-label="Cerrar selector de accesos"
  >
    ×
  </button>
  <img class="logo" src="/images/logo/art-stgo-logo-white.png" alt="Art Stgo" />
  <h2 id="access-title">¿Cómo quieres entrar?</h2>
  <p class="intro">Elige el espacio de Art Stgo que necesitas.</p>

  <div class="access-grid">
    <button type="button" class="access-card" (click)="openClientAccess()">
      <span class="access-eyebrow">Para visitar y coleccionar</span>
      <strong>Personas y coleccionistas</strong>
      <span>Descubre obras, sigue artistas y administra tu cuenta.</span>
    </button>

    @if (destinations.artistPanelUrl) {
      <button
        type="button"
        class="access-card"
        (click)="openExternal(destinations.artistPanelUrl)"
      >
        <span class="access-eyebrow">Para crear y vender</span>
        <strong>Artistas</strong>
        <span>Gestiona tu perfil, tus obras y tus ventas.</span>
      </button>
    }

    @if (hasAppDestination) {
      <article class="access-card app-card">
        <span class="access-eyebrow">Para llevar contigo</span>
        <strong>App Art Stgo</strong>
        <span>Lleva artistas, obras y actividades en tu teléfono.</span>
        @if (isDesktop) {
          <div class="store-actions">
            @if (destinations.appStoreUrl) {
              <button type="button" (click)="openStore('app-store')">
                App Store
              </button>
            }
            @if (destinations.playStoreUrl) {
              <button type="button" (click)="openStore('play-store')">
                Google Play
              </button>
            }
          </div>
        } @else {
          <button type="button" class="store-button" (click)="openStore()">
            Descargar app
          </button>
        }
      </article>
    }
  </div>

  @if (destinations.adminPanelUrl) {
    <div class="team-access">
      <span>Acceso interno</span>
      <button
        type="button"
        (click)="openExternal(destinations.adminPanelUrl)"
      >
        Equipo Art Stgo
      </button>
    </div>
  }
</section>
